// CenterImage.jsx
import React from "react";
import { useDropzone } from "react-dropzone";

export default function CenterImage({ onChange, currentImage }) {
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (!file) return;

      const previewUrl = URL.createObjectURL(file);
      onChange({ file, previewUrl });
    },
  }); 

  return (
    <div
      {...getRootProps()}
      className="border border-secondary rounded p-3 text-center bg-light"
      style={{ cursor: "pointer" }}
    >
      <input {...getInputProps()} />
      {currentImage ? (
        <img
          src={currentImage}
          alt="Preview"
          className="img-thumbnail mx-auto d-block"
          style={{ width: "120px", height: "120px", objectFit: "cover" }}
        />
      ) : (
        <p className="text-muted mb-0">Click or drag to upload image</p>
      )}
    </div>
  );
}
